import {useInfiniteQuery} from '@tanstack/react-query'
import {ApiUrls} from "../config/urls";
import axios from 'axios'
import {stringify} from "qs";
import parseParams from "./utils";
import {hydrateSearchResult} from "../utils/helpers";
import Constants from "../config/constants";

export const fetchRoutes = (queryKey, screenName, auth) => {
    let path = typeof queryKey === 'string' ? queryKey : queryKey[0];

    return axios.get(`${path}`).then((res) => {
        return hydrateSearchResult(res, screenName, auth)
    })
}

export default function useRoutes(propQuery, screenName, auth, language = null, ) {
    const query = language === null ? propQuery : {...propQuery, language: language};

    let url = ApiUrls.SEARCH.replace('{lng}', query.language);
    if (query.myroute) {
        url = ApiUrls.SEARCH_MY_ROUTE.replace('{lng}', query.language)
    }

    return useInfiniteQuery({
        queryKey: [url, query, auth?.user?.uniqKey],
        //queryKey: [url, query],
        initialPageParam: 0,
        staleTime: 0,
        queryFn: async ({ queryKey, pageParam = 0 }) => {
            let path = typeof queryKey === 'string' ? queryKey : queryKey[0];
            let params = parseParams(queryKey[1]);
            params.offset = pageParam * params.limit;

            if (queryKey[1]) {
                path += "?" + stringify(params);
            }

            return await fetchRoutes(path, screenName, auth);
        },
        getNextPageParam: (lastPage, pages) => {
            return lastPage.data.nextCursor;
        },
    });
}